import APIService from '../../../Services/APIService';
import { Apis } from '../../../Services/app.constants';

function unwrapGet(res) {
  return {
    ok: res.status >= 200 && res.status < 300,
    data: res.data,
    status: res.status,
  };
}

function unwrapMutation(res) {
  const body = res?.data;
  if (res.status >= 200 && res.status < 300 && body?.status === true) {
    return { ok: true, data: body.data, status: res.status };
  }
  return { ok: false, data: body?.data ?? body, status: res.status };
}

export async function listCampaignTemplates(params = {}) {
  const q = new URLSearchParams();
  if (params.business_type_id) q.set('business_type_id', params.business_type_id);
  if (params.goal) q.set('goal', params.goal);
  if (params.is_active !== undefined && params.is_active !== '') {
    q.set('is_active', params.is_active);
  }
  const qs = q.toString();
  const url = qs
    ? `${Apis.setupWizardCampaignFormTemplatesManage}?${qs}`
    : Apis.setupWizardCampaignFormTemplatesManage;
  const res = await APIService.get(url);
  const payload = unwrapGet(res);
  return {
    ...payload,
    items: payload.data?.items ?? [],
  };
}

export async function getCampaignTemplate(id) {
  const res = await APIService.get(Apis.setupWizardCampaignFormTemplateDetail(id));
  return unwrapGet(res);
}

export async function createCampaignTemplate(body) {
  const res = await APIService.post(Apis.setupWizardCampaignFormTemplatesManage, body);
  return unwrapMutation(res);
}

export async function updateCampaignTemplate(id, body) {
  const res = await APIService.patch(Apis.setupWizardCampaignFormTemplateDetail(id), body);
  return unwrapMutation(res);
}

export async function deleteCampaignTemplate(id) {
  const res = await APIService.remove(Apis.setupWizardCampaignFormTemplateDetail(id));
  return unwrapMutation(res);
}
